"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorTargetChip = exports.VendorTargetStateBadge = exports.VENDOR_TARGET_STATE_VARIANT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const badge_1 = require("../ui/badge");
exports.VENDOR_TARGET_STATE_VARIANT = {
    PENDING: 'muted',
    IN_FLIGHT: 'warning',
    PUBLISHED: 'success',
    REVISED: 'success',
    RECALLED: 'outline',
    FAILED: 'destructive',
    SKIPPED_NO_CHANGE: 'secondary',
    RECALL_MANUAL_REQUIRED: 'destructive',
    RECALLED_MANUALLY: 'outline',
};
const VendorTargetStateBadge = ({ state }) => (0, jsx_runtime_1.jsx)(badge_1.Badge, { variant: exports.VENDOR_TARGET_STATE_VARIANT[state], children: state });
exports.VendorTargetStateBadge = VendorTargetStateBadge;
const SENT = ['PUBLISHED', 'REVISED'];
// List rows: a sent vendor is just its name in green, so three vendors fit on one line;
// anything else keeps the state in the chip. The full state is on hover.
const VendorTargetChip = ({ vendorKey, state }) => ((0, jsx_runtime_1.jsx)(badge_1.Badge, { variant: exports.VENDOR_TARGET_STATE_VARIANT[state], title: `${vendorKey}: ${state}`, children: SENT.includes(state) ? vendorKey : `${vendorKey} · ${state}` }));
exports.VendorTargetChip = VendorTargetChip;
